import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-452dd2cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "quan-ly-nhap-kho-create__title" }, " Biên bản kiểm nghiệm phiếu nhập kho ", -1))
const _hoisted_2 = { class: "quan-ly-nhap-kho-create__fields" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = {
  key: "hop-dong",
  class: "d-flex flex-column align-items-start w-100"
}
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = {
  key: "tai-khoan",
  class: "d-flex flex-column align-items-start w-100"
}
const _hoisted_8 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_9 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_10 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_11 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_12 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_13 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_14 = {
  key: 0,
  class: "quan-ly-nhap-kho-create__vat-tu-heading"
}
const _hoisted_15 = {
  key: 1,
  class: "quan-ly-nhap-kho-create__toolbar"
}

import {
  buildPhieuNhapKhoCreatePayload,
  getChiTietPhieuNhapKhoParams,
} from "@/components/phieu-nhap-kho";
import type { IVatTuDaChon } from "@/components/add-vat-tu-items/AddVatTuItems.vue";
import AddVatTuItems from "@/components/add-vat-tu-items/AddVatTuItems.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import NguoiKiemNghiem, {
  type INguoiKiemNghiem,
} from "@/components/shared/nguoi-kiem-nghiem/NguoiKiemNghiem.vue";
import TaiKhoanSelectionV2 from "@/components/shared/tai-khoan-selection/TaiKhoanSelectionV2.vue";
import { AddVatTuItemsFor } from "@/core/enums/addVatTuItemsFor.enum";
import { setBreadcrumbLinks, setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {
  getErrorMsg,
  getHoiDongBbkn,
  getPhieuNhapKhoFormDraft,
  setHoiDongBbkn,
  setPhieuNhapKhoFormDraft,
  swalErrNotification,
  swalNotification,
} from "@/core/helpers/utils";
import { useAccount } from "@/core/hooks/use-account";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import {
  formatDatePayload,
  getGlobalDefaultDate,
  useDateTime,
} from "@/core/hooks/use-date-time-hook";
import { useLoading } from "@/core/hooks/use-loading";
import useTaiKhoan from "@/core/hooks/useTaiKhoan";
import {
  IHopDongResponseBase,
  IKhoResponseBase,
  IVatTuBienBan,
  IVatTuPhieuNhapKho,
} from "@/core/interfaces/ApiResponses";
import { HopDongService } from "@/core/services/HopDong.service";
import { KhoService } from "@/core/services/Kho.service";
import { PhieuNhapKhoService } from "@/core/services/PhieuNhapKho.service";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageContentSection from "@/layout/_shared/PageContentSection.vue";
import type {
  HopDongVatTuSelectionRow,
  PhieuNhapKhoVatTuLineInput,
} from "@/types/phieu-nhap-kho";
import VatTuBienBanTable from "@/views/crafted/pages/bien-ban-kiem-nghiem/vat-tu-bien-ban-kiem-nghiem/VatTuBienBanTable.vue";
import anime from "animejs/lib/anime.es.js";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

type LoaiPhieuMode = "theo_hop_dong" | "khong_theo_hop_dong";

interface VatTuBienBanTableExpose {
  items: IVatTuBienBan[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  setup(__props) {

document.title = "Biên bản kiểm nghiệm phiếu nhập kho - Đường sắt Hà Nội";

const router = useRouter();
const { commit } = useStore();
const { startLoading, endLoading } = useLoading();
const { ButtonsType, ButtonTypeColors } = useButtonCustom();
const { tkData, onSelectTaiKhoan, clearTaiKhoanData } = useTaiKhoan();
const { currentUserData } = useAccount();
const { moment } = useDateTime();
const idDonVi = currentUserData.value.departmentId;

const submitBtnWrap = ref<HTMLElement | null>(null);
let submitPulseAnim: anime.AnimeInstance | null = null;

const getSubmitButtonEl = () =>
  submitBtnWrap.value?.querySelector(
    ".quan-ly-nhap-kho-create__btn--submit"
  ) as HTMLElement | null;

const startSubmitButtonAnimation = () => {
  const btn = getSubmitButtonEl();

  if (!btn || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  submitPulseAnim?.pause();
  anime.remove(btn);

  submitPulseAnim = anime({
    targets: btn,
    scale: [1, 1.035, 1],
    boxShadow: [
      "0 0 0 0 rgba(201, 247, 245, 0)",
      "0 0 18px 6px rgba(201, 247, 245, 0.85), 0 0 28px 10px rgba(80, 205, 137, 0.2)",
      "0 0 0 0 rgba(201, 247, 245, 0)",
    ],
    textShadow: [
      "0 0 0 rgba(236, 253, 245, 0)",
      "0 0 10px rgba(236, 253, 245, 0.95), 0 0 18px rgba(255, 255, 255, 0.75)",
      "0 0 0 rgba(236, 253, 245, 0)",
    ],
    duration: 2200,
    easing: "easeInOutSine",
    loop: true,
  });
};

const playSubmitClickAnimation = () => {
  const btn = getSubmitButtonEl();

  if (!btn) {
    return;
  }

  submitPulseAnim?.pause();
  anime.remove(btn);

  anime({
    targets: btn,
    scale: [1, 0.95, 1.02, 1],
    boxShadow: [
      "0 0 0 0 rgba(201, 247, 245, 0)",
      "0 0 10px 3px rgba(201, 247, 245, 0.7)",
      "0 0 22px 8px rgba(201, 247, 245, 0.95)",
      "0 0 0 0 rgba(201, 247, 245, 0)",
    ],
    textShadow: [
      "0 0 0 rgba(236, 253, 245, 0)",
      "0 0 6px rgba(255, 255, 255, 0.9)",
      "0 0 14px rgba(236, 253, 245, 1)",
      "0 0 0 rgba(236, 253, 245, 0)",
    ],
    duration: 480,
    easing: "easeOutQuad",
    complete: () => {
      startSubmitButtonAnimation();
    },
  });
};

const onSubmitClick = async () => {
  playSubmitClickAnimation();
  await onSubmit();
};

const formRef = ref();
const khoItems = ref<IKhoResponseBase[]>([]);
const hopDongOptions = ref<IHopDongResponseBase[]>([]);
const hopDongDetail = ref<IHopDongResponseBase | null>(null);
const searchingHopDong = ref(false);
const isAddVatTuModalDisplay = ref(false);
const vatTuDangChonItems = ref<IVatTuPhieuNhapKho[]>([]);
const vatTuBienBanItems = ref<IVatTuBienBan[]>([]);
const vatTuItemsDisplay = ref<IVatTuBienBan[]>([]);

const tamNhapVatTuTableRef = ref<VatTuBienBanTableExpose | null>(null);

const buildDefaultHoiDong = (): INguoiKiemNghiem[] =>
  Array.from({ length: 4 }, (_, i) => ({
    thuTu: i + 1,
    hoTen: "",
    chucVu: "",
    thanhPhan: "",
  }));

const resolveInitialHoiDong = (): INguoiKiemNghiem[] => {
  const stored = getHoiDongBbkn();

  return stored.length > 0 ? stored : buildDefaultHoiDong();
};

const hoiDongKiemNghiem = ref<INguoiKiemNghiem[]>(resolveInitialHoiDong());

const formDraft = getPhieuNhapKhoFormDraft();

const form = ref({
  loai_phieu_mode: "theo_hop_dong" as LoaiPhieuMode,
  id_hop_dong: 0,
  kho_id: 0,
  ngay_bien_ban: getGlobalDefaultDate(),
  giam_doc: formDraft.giam_doc ?? "",
  nguoi_giao: formDraft.nguoi_giao ?? "",
  so_hoa_don: "",
  ngay_hoa_don: null as Date | null,
  y_kien: formDraft.y_kien ?? "",
});

const persistFormDraft = () => {
  setPhieuNhapKhoFormDraft({
    nguoi_giao: form.value.nguoi_giao,
    giam_doc: form.value.giam_doc,
    y_kien: form.value.y_kien,
  });
};

const isTheoHopDong = computed(
  () => form.value.loai_phieu_mode === "theo_hop_dong"
);

const allowEditingDonGia = computed(
  () => Number(hopDongDetail.value?.loai_hop_dong) === 2
);

const availableKhoItems = computed(() => [
  { label: "Chưa chọn", value: 0 },
  ...(khoItems.value ?? []).map((item) => ({
    value: item.id,
    label: item.ten_kho,
  })),
]);

const rules = computed(() => ({
  loai_phieu_mode: [
    {
      required: true,
      message: "Phải chọn loại phiếu",
      trigger: "change",
    },
  ],
  kho_id: [
    {
      type: "number",
      min: 1,
      message: "Phải chọn kho",
      trigger: "change",
    },
  ],
  ...(isTheoHopDong.value && {
    id_hop_dong: [
      {
        type: "number",
        min: 1,
        message: "Phải chọn hợp đồng",
        trigger: "change",
      },
    ],
  }),
  giam_doc: [
    {
      required: true,
      message: "Bắt buộc phải nhập",
      trigger: "blur",
    },
  ],
  ngay_bien_ban: [
    {
      required: true,
      message: "Phải nhập ngày",
      trigger: "blur",
    },
  ],
  y_kien: [
    {
      validator: (_: unknown, value: string, cb: (error?: Error) => void) => {
        if (!value || value.trim() === "") {
          cb(new Error("Không được để trống"));
        } else {
          cb();
        }
      },
      trigger: "blur",
    },
  ],
}));

const resolveHopDongVatTuDonGia = (
  row: HopDongVatTuSelectionRow & {
    pivot?: { so_tien?: number; don_gia?: number };
  }
) =>
  Number(
    row.don_gia_hd ??
      row.don_gia ??
      row.pivot?.so_tien ??
      row.pivot?.don_gia ??
      0
  );

const mapVatTuPhieuNhapToBienBanRow = (
  vatTuItem: IVatTuPhieuNhapKho
): IVatTuBienBan => ({
  ...vatTuItem,
  so_luong_trong_bien_ban: +vatTuItem.pivot.so_luong,
  so_luong_can: 0,
  phuong_thuc: vatTuItem.pivot.phuong_thuc_kiem_nghiem ?? "",
  is_dat: (vatTuItem.pivot.ket_qua_kiem_nghiem ?? 1) === 1,
  so_luong_nhap_toi_da: 0,
  pivot: {
    id_hop_dong: 0,
    id_vat_tu: vatTuItem.id,
    so_luong: +vatTuItem.pivot.so_luong,
    so_tien: +vatTuItem.pivot.don_gia,
  },
});

const syncVatTuItemsDisplay = () => {
  vatTuItemsDisplay.value = vatTuDangChonItems.value.map(
    mapVatTuPhieuNhapToBienBanRow
  );
};

const syncTamNhapVatTuFromTable = () => {
  const tableItems = tamNhapVatTuTableRef.value?.items ?? [];

  tableItems.forEach((row) => {
    const item = vatTuDangChonItems.value.find((vatTu) => vatTu.id === row.id);

    if (!item) {
      return;
    }

    item.pivot.so_luong = +row.so_luong_trong_bien_ban;
    item.pivot.don_gia = +row.pivot.so_tien;
    item.don_gia = +row.pivot.so_tien;
    item.pivot.phuong_thuc_kiem_nghiem = row.phuong_thuc ?? "";
  });
};

const clearVatTuState = () => {
  vatTuBienBanItems.value = [];
  vatTuDangChonItems.value = [];
  vatTuItemsDisplay.value = [];
  hopDongDetail.value = null;
  form.value.id_hop_dong = 0;
};

const onLoaiPhieuModeChange = () => {
  clearVatTuState();
  clearTaiKhoanData("tai_khoan");
};

const searchHopDong = async (query: string) => {
  searchingHopDong.value = true;

  try {
    const {
      data: {
        data: { data },
      },
    } = await HopDongService.fetchAllContracts({
      current_page: 1,
      per_page: 2000,
      searchTerm: query,
    });

    hopDongOptions.value = data;
  } finally {
    searchingHopDong.value = false;
  }
};

const loadHopDongVatTu = async (idHopDong: number) => {
  const { data: response } = await PhieuNhapKhoService.getHopDongVatTu(
    idHopDong
  );

  const raw = response.data;
  const rows: HopDongVatTuSelectionRow[] = Array.isArray(raw)
    ? raw
    : Array.isArray((raw as { data?: HopDongVatTuSelectionRow[] }).data)
    ? (raw as { data: HopDongVatTuSelectionRow[] }).data
    : [];

  vatTuBienBanItems.value = rows.map((row) => {
    const vatTuId = row.id_vat_tu ?? row.id;

    return {
      id: vatTuId,
      ma_vat_tu: row.ma_vat_tu,
      ten_vat_tu: row.ten_vat_tu,
      don_vi_tinh: row.don_vi_tinh,
      is_valid: row.is_valid,
      phuong_thuc: "",
      so_luong_trong_bien_ban: 0,
      so_luong_can: row.so_luong_con_lai,
      so_luong_nhap_toi_da: row.so_luong_con_lai,
      is_dat: true,
      pivot: {
        id_hop_dong: idHopDong,
        id_vat_tu: vatTuId,
        so_luong: +row.so_luong_hd,
        so_tien: resolveHopDongVatTuDonGia(row),
      },
    };
  });
};

const onHopDongChange = async (idHopDong: number) => {
  if (!idHopDong) {
    clearVatTuState();

    return;
  }

  try {
    startLoading();

    const {
      data: { data },
    } = await HopDongService.fetchContractDetail(idHopDong);

    hopDongDetail.value = data;
    await loadHopDongVatTu(idHopDong);
    endLoading();
  } catch (e) {
    endLoading();
    hopDongDetail.value = null;
    vatTuBienBanItems.value = [];
    await swalErrNotification(e, "Có lỗi khi lấy thông tin hợp đồng");
  }
};

const fetchKhoItems = async () => {
  const {
    data: {
      data: { data: response },
    },
  } = await KhoService.fetchAllWarehousesByDepartmentId(idDonVi);

  khoItems.value = [...response];
};

const buildInvoiceFields = () => {
  const soHoaDon = form.value.so_hoa_don?.trim() || null;
  const formattedNgay = form.value.ngay_hoa_don
    ? formatDatePayload(form.value.ngay_hoa_don)
    : "";

  return {
    so_hoa_don: soHoaDon,
    ngay_hoa_don: formattedNgay || null,
    nguoi_giao: form.value.nguoi_giao?.trim() || null,
  };
};

const buildBienBanFields = () => ({
  ngay_bien_ban: formatDatePayload(form.value.ngay_bien_ban),
  thanh_phan_hoi_dong: hoiDongKiemNghiem.value,
  y_kien: form.value.y_kien,
  ten_giam_doc: form.value.giam_doc,
});

const getTamNhapChiTietLines = (): PhieuNhapKhoVatTuLineInput[] => {
  return vatTuDangChonItems.value
    .filter(({ pivot: { so_luong } }: IVatTuPhieuNhapKho) => +so_luong > 0)
    .map((vatTu: IVatTuPhieuNhapKho) => ({
      id: vatTu.id,
      so_luong: +vatTu.pivot.so_luong,
      don_gia: +vatTu.pivot.don_gia,
      ket_qua_kiem_nghiem: 1 as const,
      phuong_thuc_kiem_nghiem: vatTu.pivot.phuong_thuc_kiem_nghiem,
    }));
};

const getHopDongChiTietLines = (): PhieuNhapKhoVatTuLineInput[] => {
  return vatTuBienBanItems.value
    .filter((item) => item.so_luong_trong_bien_ban > 0)
    .map((item) => ({
      id: item.id,
      so_luong: item.so_luong_trong_bien_ban,
      so_tien: item.pivot.so_tien,
      ket_qua_kiem_nghiem: (item.is_dat ? 1 : 0) as 0 | 1,
      phuong_thuc_kiem_nghiem: item.phuong_thuc,
    }));
};

const transformSelectingVatTuToVatTuPhieuNhap = (items: IVatTuDaChon[]) => {
  vatTuDangChonItems.value = items.map((item: IVatTuDaChon) => ({
    ...item,
    pivot: {
      don_gia: item.don_gia,
      id_phieu_nhap_kho: 0,
      id_vat_tu: item.id,
      so_luong: +item.so_luong,
      is_dat: 1,
      ket_qua_kiem_nghiem: 1,
      phuong_thuc_kiem_nghiem: "",
    },
  }));

  syncVatTuItemsDisplay();
};

const onAddedVatTuItems = ({
  vatTuDangChon: items,
}: {
  vatTuDangChon: IVatTuDaChon[];
}) => {
  isAddVatTuModalDisplay.value = false;
  transformSelectingVatTuToVatTuPhieuNhap(items);
};

const onInputChange = ({ items }: { items: IVatTuBienBan[] }) => {
  vatTuBienBanItems.value = [...items];
};

const handleDonGiaUpdate = ({
  index,
  value,
}: {
  index: number;
  value: number;
}) => {
  const item = vatTuBienBanItems.value[index];

  if (!item || +item.pivot.so_tien === +value) {
    return;
  }

  item.pivot.so_tien = +value;
};

const onInputPhuongThuc = ({
  index,
  value,
}: {
  index: number;
  value: string;
}) => {
  vatTuBienBanItems.value[index].phuong_thuc = value;
};

const changePhuongThuc = ({
  index,
  value,
}: {
  index: number;
  value: string;
}) => {
  const displayItem = vatTuItemsDisplay.value[index];

  if (!displayItem) {
    return;
  }

  const vatTuItem = vatTuDangChonItems.value.find(
    (item) => item.id === displayItem.id
  );

  if (vatTuItem) {
    vatTuItem.pivot.phuong_thuc_kiem_nghiem = value;
  }
};

const handleSoLuongUpdate = ({
  items,
  id_vat_tu,
}: {
  items: IVatTuBienBan[];
  id_vat_tu: number;
}) => {
  const vatTuItemIndex = vatTuDangChonItems.value.findIndex(
    (vatTu) => vatTu.id === id_vat_tu
  );
  const updatedItem = items.find((item) => item.id === id_vat_tu);

  if (vatTuItemIndex >= 0 && updatedItem) {
    const item = vatTuDangChonItems.value[vatTuItemIndex];

    item.pivot.so_luong = +updatedItem.so_luong_trong_bien_ban;
    item.pivot.don_gia = +updatedItem.pivot.so_tien;
    item.don_gia = +updatedItem.pivot.so_tien;
    item.pivot.phuong_thuc_kiem_nghiem = updatedItem.phuong_thuc ?? "";
  }
};

const handleTamNhapDonGiaUpdate = ({
  index,
  value,
}: {
  index: number;
  value: number;
}) => {
  const displayItem = vatTuItemsDisplay.value[index];

  if (!displayItem) {
    return;
  }

  const item = vatTuDangChonItems.value.find(
    (vatTu) => vatTu.id === displayItem.id
  );

  if (!item) {
    return;
  }

  item.pivot.don_gia = +value;
  item.don_gia = +value;
};

const focusFirstSoLuongInput = async () => {
  await nextTick();

  const soLuongInputElement = document.querySelector(
    "#vat-tu-_so-luong-input_1 input"
  );

  if (soLuongInputElement) {
    (soLuongInputElement as HTMLInputElement).focus();
  }
};

const focusFirstFormError = async () => {
  await nextTick();

  const firstErrInput = document.querySelector(
    ".el-form-item.is-error input, .el-form-item.is-error textarea"
  );

  if (firstErrInput) {
    (firstErrInput as HTMLInputElement).focus();
    firstErrInput.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

const submitCreate = async () => {
  commit("ConfirmationDialogModule/closeDialog");

  if (!isTheoHopDong.value) {
    syncTamNhapVatTuFromTable();
  }

  const chiTiet = isTheoHopDong.value
    ? getHopDongChiTietLines()
    : getTamNhapChiTietLines();

  if (chiTiet.length === 0) {
    await focusFirstSoLuongInput();

    await swalNotification(
      isTheoHopDong.value
        ? "Bắt buộc phải nhập ít nhất một vật tư có số lượng lớn hơn 0"
        : "Bắt buộc phải nhập vật tư trong phiếu nhập và ít nhất phải có một vật tư có số lượng lớn hơn 0",
      "error"
    );

    return;
  }

  setHoiDongBbkn(hoiDongKiemNghiem.value);
  persistFormDraft();

  try {
    await startLoading();

    const phieuNhap = isTheoHopDong.value
      ? {
          id_hop_dong: form.value.id_hop_dong,
          id_kho: form.value.kho_id,
          ...buildInvoiceFields(),
        }
      : {
          id_hop_dong: 0,
          id_kho: form.value.kho_id,
          ma_tk_co: tkData.value.maTaiKhoan,
          ...(tkData.value.maChiTiet && {
            ma_ct_co: tkData.value.maChiTiet,
          }),
          ten_tk_co: tkData.value.tenTaiKhoan,
          ...buildInvoiceFields(),
        };

    const payload = buildPhieuNhapKhoCreatePayload({
      phieuNhap,
      bienBanKiemNghiem: buildBienBanFields(),
      chiTiet,
    });

    const {
      data: { data },
    } = await PhieuNhapKhoService.create(payload);

    await endLoading();
    await swalNotification(
      isTheoHopDong.value
        ? "Tạo phiếu nhập kho & biên bản kiểm nghiệm thành công"
        : "Tạo phiếu nhập khác thành công"
    );

    await router.replace({
      name: "chi-tiet-phieu-nhap-kho",
      params: getChiTietPhieuNhapKhoParams(data.id),
    });
  } catch (e) {
    await endLoading();

    const msg = (e as { response?: { data?: { data?: { msg?: string } } } })
      .response?.data?.data?.msg;

    if (
      msg ===
        "Dữ liệu biên bản kiểm nghiệm không có dữ liệu. Vui lòng kiểm tra lại!" ||
      msg === "Số lượng bắt buộc nhập" ||
      msg === "Danh sách vật tư (chiTiet) không được để trống"
    ) {
      await focusFirstSoLuongInput();
    }

    await swalNotification(
      getErrorMsg(
        e,
        isTheoHopDong.value
          ? "Có lỗi, không tạo được biên bản"
          : "Có lỗi xảy ra khi lưu phiếu nhập"
      ),
      "error"
    );
  }
};

const onSubmit = async () => {
  if (
    !isTheoHopDong.value &&
    (!tkData.value.maTaiKhoan || !tkData.value.tenTaiKhoan)
  ) {
    await nextTick();

    const taiKhoanInput = document.querySelector(
      "#tai-khoan-selection_tai-khoan"
    );

    if (taiKhoanInput) {
      (taiKhoanInput as HTMLInputElement).focus();
    }

    await swalNotification("Bắt buộc phải nhập thông tin tài khoản", "error");

    return;
  }

  if (!formRef.value) {
    return;
  }

  const formInstance = formRef.value as {
    validate: (callback: (valid: boolean) => void) => void;
  };

  formInstance.validate(async (valid: boolean) => {
    if (!valid) {
      await focusFirstFormError();

      return false;
    }

    commit("ConfirmationDialogModule/setDialog", {
      title: "Xác nhận",
      message: isTheoHopDong.value
        ? "Tạo mới phiếu nhập kho & BBKN với những thông tin này không?"
        : "Bạn có chắc chắn muốn lưu phiếu nhập kho này không?",
      cancelText: "Hủy",
      onConfirm: submitCreate,
    });
  });
};

onMounted(async () => {
  setBreadcrumbLinks([
    {
      text: "Quản lý nhập kho",
      routeData: { name: "danh-sach-quan-ly-nhap-kho" },
    },
    { text: "Tạo mới" },
  ]);
  setCurrentPageTitle("Biên bản kiểm nghiệm phiếu nhập kho");

  try {
    startLoading();
    await fetchKhoItems();
    await searchHopDong("");
    endLoading();
  } catch (e) {
    endLoading();
    await swalErrNotification(e, "Có lỗi khi tải dữ liệu form");
  }

  await nextTick();
  startSubmitButtonAnimation();
});

onBeforeUnmount(() => {
  const btn = getSubmitButtonEl();

  submitPulseAnim?.pause();
  submitPulseAnim = null;

  if (btn) {
    anime.remove(btn);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AddVatTuItems, {
      "is-modal-open": isAddVatTuModalDisplay.value,
      "use-for": _unref(AddVatTuItemsFor).PHIEU_NHAP_LE,
      "vat-tu-da-chon-items": vatTuDangChonItems.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddVatTuModalDisplay.value = false)),
      onAdded: onAddedVatTuItems
    }, null, 8, ["is-modal-open", "use-for", "vat-tu-da-chon-items"]),
    _createVNode(PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(PageContentSection, { "always-expanded": true }, {
          header: _withCtx(() => [
            _createTextVNode("Tạo mới")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "formRef",
              ref: formRef,
              class: "quan-ly-nhap-kho-create",
              model: form.value,
              rules: rules.value,
              onSubmit: _withModifiers(onSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_el_alert, {
                  class: "quan-ly-nhap-kho-create__alert",
                  closable: false,
                  "show-icon": "",
                  type: "info",
                  title: "Phiếu nhập kho sẽ được tự động tạo sau khi tạo BBKN thành công"
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                    default: _withCtx(() => [
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(LabelCustom, {
                              "is-bolder": true,
                              "is-required": true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Kho ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "mb-0 w-100",
                              prop: "kho_id"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  id: "kho-select_input",
                                  modelValue: form.value.kho_id,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.kho_id) = $event)),
                                  class: "w-100",
                                  filterable: "",
                                  name: "kho_id",
                                  placeholder: "Chọn kho"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableKhoItems.value, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: option.value,
                                        label: option.label,
                                        value: option.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(LabelCustom, {
                              "is-bolder": true,
                              "is-required": true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Loại phiếu ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "mb-0 w-100",
                              prop: "loai_phieu_mode"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: form.value.loai_phieu_mode,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.loai_phieu_mode) = $event)),
                                  class: "w-100",
                                  placeholder: "Chọn loại phiếu",
                                  onChange: onLoaiPhieuModeChange
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "Theo hợp đồng",
                                      value: "theo_hop_dong"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "Không theo hợp đồng",
                                      value: "khong_theo_hop_dong"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_Transition, {
                            name: "qlnk-field-fade",
                            mode: "out-in"
                          }, {
                            default: _withCtx(() => [
                              (isTheoHopDong.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(LabelCustom, {
                                      "is-bolder": true,
                                      "is-required": true
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Hợp đồng ")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "mb-0 w-100",
                                      prop: "id_hop_dong"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: form.value.id_hop_dong,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.id_hop_dong) = $event)),
                                          class: "w-100",
                                          filterable: "",
                                          remote: "",
                                          clearable: "",
                                          placeholder: "Tìm hợp đồng",
                                          "remote-method": searchHopDong,
                                          loading: searchingHopDong.value,
                                          "loading-text": "đang tìm kiếm ...",
                                          onChange: onHopDongChange
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              disabled: "",
                                              label: "Tìm hợp đồng",
                                              value: 0
                                            }),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hopDongOptions.value, (hopDong) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: hopDong.id,
                                                label: hopDong.so_hop_dong,
                                                value: hopDong.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_6, _toDisplayString(hopDong.so_hop_dong), 1),
                                                  _createTextVNode(" - " + _toDisplayString(hopDong.ten_doi_tac), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "loading"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(LabelCustom, {
                                      "is-bolder": true,
                                      "is-required": true
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Tài khoản kế toán ")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(TaiKhoanSelectionV2, {
                                      class: "w-100",
                                      "ma-tai-khoan-prop": _unref(tkData).maTaiKhoan,
                                      "ma-chi-tiet-prop": 
                      _unref(tkData).maChiTiet ? _unref(tkData).maChiTiet : undefined
                    ,
                                      "ten-tai-khoan-prop": _unref(tkData).tenTaiKhoan,
                                      onOnClear: _unref(clearTaiKhoanData),
                                      onOnSelect: _unref(onSelectTaiKhoan)
                                    }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop", "onOnClear", "onOnSelect"])
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                    default: _withCtx(() => [
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(LabelCustom, {
                              "is-bolder": true,
                              "is-required": true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ngày biên bản ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "w-100 mb-0",
                              prop: "ngay_bien_ban"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: form.value.ngay_bien_ban,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.ngay_bien_ban) = $event)),
                                  class: "w-100",
                                  format: "DD/MM/YYYY",
                                  name: "ngay_bien_ban",
                                  placeholder: "Chọn ngày",
                                  onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(LabelCustom, { "is-bolder": true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Số hóa đơn")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_input, {
                              modelValue: form.value.so_hoa_don,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.so_hoa_don) = $event)),
                              class: "w-100"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(LabelCustom, { "is-bolder": true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ngày hóa đơn")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_date_picker, {
                              modelValue: form.value.ngay_hoa_don,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.ngay_hoa_don) = $event)),
                              "allow-before-global-min": "",
                              class: "w-100",
                              format: "DD/MM/YYYY",
                              placeholder: "Chọn ngày"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(LabelCustom, { "is-bolder": true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Họ & tên người giao")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_input, {
                              modelValue: form.value.nguoi_giao,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.nguoi_giao) = $event)),
                              class: "w-100",
                              name: "nguoi_giao",
                              placeholder: "Mời nhập tên",
                              onBlur: persistFormDraft
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                    default: _withCtx(() => [
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 3
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(LabelCustom, {
                              "is-bolder": true,
                              "is-required": true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Giám đốc ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "mb-0 w-100",
                              prop: "giam_doc"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: form.value.giam_doc,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.giam_doc) = $event)),
                                  name: "giam_doc",
                                  placeholder: "Mời nhập tên",
                                  onBlur: persistFormDraft
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(DivCol, {
                        "additional-class": "pb-2",
                        cols: 9
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(LabelCustom, {
                              "is-bolder": true,
                              "is-required": true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ý kiến HĐKN ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "mb-0 w-100",
                              prop: "y_kien"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: form.value.y_kien,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.y_kien) = $event)),
                                  placeholder: "Mời nhập ý kiến",
                                  autosize: { minRows: 1 },
                                  resize: "none",
                                  type: "textarea",
                                  onBlur: persistFormDraft
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(NguoiKiemNghiem, {
                  "model-value": hoiDongKiemNghiem.value,
                  "giam-doc-name": form.value.giam_doc,
                  "onUpdate:giamDocName": _cache[11] || (_cache[11] = ($event: any) => ((form.value.giam_doc) = $event)),
                  "is-editable": true,
                  "show-giam-doc-input": false,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (hoiDongKiemNghiem.value = $event))
                }, null, 8, ["model-value", "giam-doc-name"]),
                (isTheoHopDong.value && hopDongDetail.value)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_14, [
                      _createTextVNode(" Đã tiến hành kiểm nghiệm các loại vật tư theo hợp đồng số "),
                      _createElementVNode("strong", null, _toDisplayString(hopDongDetail.value.so_hop_dong), 1),
                      _createTextVNode(" ngày "),
                      _createElementVNode("strong", null, _toDisplayString(_unref(moment)(hopDongDetail.value.ngay_ky).format("DD/MM/YYYY")), 1),
                      _createTextVNode(" như sau: ")
                    ]))
                  : _createCommentVNode("", true),
                (!isTheoHopDong.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(ButtonCustom, {
                        classes: "quan-ly-nhap-kho-create__btn",
                        "button-type": _unref(ButtonsType).ADD,
                        "color-type": _unref(ButtonTypeColors).SUCCESS,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (isAddVatTuModalDisplay.value = true))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("Thêm hoặc xoá vật tư")
                        ]),
                        _: 1
                      }, 8, ["button-type", "color-type"])
                    ]))
                  : _createCommentVNode("", true),
                (isTheoHopDong.value && vatTuBienBanItems.value.length)
                  ? (_openBlock(), _createBlock(VatTuBienBanTable, {
                      key: 2,
                      "allow-editing-don-gia": allowEditingDonGia.value,
                      "for-phieu-nhap-le": false,
                      "is-editable": true,
                      "vat-tu-items": vatTuBienBanItems.value,
                      onChangeDonGia: handleDonGiaUpdate,
                      onOnChange: onInputChange,
                      onOnChangePhuongThuc: onInputPhuongThuc
                    }, null, 8, ["allow-editing-don-gia", "vat-tu-items"]))
                  : _createCommentVNode("", true),
                (!isTheoHopDong.value)
                  ? (_openBlock(), _createBlock(VatTuBienBanTable, {
                      key: 3,
                      ref_key: "tamNhapVatTuTableRef",
                      ref: tamNhapVatTuTableRef,
                      "allow-editing-don-gia": true,
                      "for-phieu-nhap-le": true,
                      "is-editable": true,
                      "vat-tu-items": vatTuItemsDisplay.value,
                      onChangeDonGia: handleTamNhapDonGiaUpdate,
                      onOnChangePhuongThuc: changePhuongThuc,
                      onOnChange: _cache[14] || (_cache[14] = (payload) => handleSoLuongUpdate(payload))
                    }, null, 8, ["vat-tu-items"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  ref_key: "submitBtnWrap",
                  ref: submitBtnWrap,
                  class: "quan-ly-nhap-kho-create__actions"
                }, [
                  _createVNode(ButtonCustom, {
                    classes: "quan-ly-nhap-kho-create__btn quan-ly-nhap-kho-create__btn--submit",
                    "button-type": _unref(ButtonsType).FA_FILE_CIRCLE_PLUS,
                    "color-type": _unref(ButtonTypeColors).SUCCESS,
                    onClick: onSubmitClick
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(isTheoHopDong.value ? "Tạo phiếu" : "Lưu phiếu nhập"), 1)
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"])
                ], 512)
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})